import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import FormField from './FormField.jsx';

let schemaStub = {
  isRequired: () => false,
  getField: () => ({}),
  getValidators: () => [],
};

const schemaAwareField = (WrappedComponent) => ({
  className,
  name,
  schema = schemaStub,
  schemaOptions,
  ...props
}) => (
  <WrappedComponent
    className={classNames({
      'required': schema.isRequired(name),
    }, className)}
    isRequired={schema.isRequired(name)}
    label={schema.getField(name).title}
    name={name}
    validate={schema.getValidators(name, schemaOptions)}
    {...props}
  />
);

export { schemaAwareField };

let SchemaAwareFormField = schemaAwareField(FormField);

export default SchemaAwareFormField;
